/**
 * FOOTARCHY INTERACTIVE SCRIPTS - SHOPIFY OS 2.0 (DARK LUXURY & INP EDITION)
 * Rendimiento puro: Vanilla ES6+, Cero dependencias externas (<10KB).
 * Optimizaciones quirúrgicas aplicadas por el Árbitro:
 * 1. Dark Theme System por defecto ('dark' #0D0D0D nativo sin sobrescritura a 'light' en DOMContentLoaded)
 * 2. Before/After Slider táctil sin Layout Thrashing (rect cacheado en pointerdown + requestAnimationFrame)
 * 3. Sticky Add-to-Cart móvil con guarda anti-colisión frente al controlador nativo de PDP
 * 4. Volume Tier / Bundle Selector compatible con secciones genéricas sin pisar la PDP
 * 5. Acordeones Técnicos con blindaje anti-doble-listener (respeta onclick inline y #ftPdpRoot)
 * 6. Ajax Add to Cart con Mutex anti-duplicidad y sincronización directa con Footarchy Cart Drawer
 * 7. Feedback táctil INP < 50ms sin alterar botones posicionados con transform (flechas de galería/acordeones)
 */

document.addEventListener('DOMContentLoaded', () => {
  initFootarchyInteractive();
});

// Soporte para recargas en el editor visual de Shopify (Customizer)
document.addEventListener('shopify:section:load', () => {
  initFootarchyInteractive();
});

function initFootarchyInteractive() {
  initThemeSystem();
  initBeforeAfterSliders();
  initStickyAddToCart();
  initBundleSelectors();
  initTechnicalAccordions();
  initAjaxCartForms();
  initButtonFastFeedback();
}

/* ==========================================================================
   1. DARK / LIGHT THEME SYSTEM (DARK #0D0D0D POR DEFECTO)
   ========================================================================== */
function initThemeSystem() {
  let saved = 'dark';
  try {
    saved = localStorage.getItem('ft_theme') || 'dark';
  } catch (e) {
    saved = 'dark';
  }
  document.documentElement.setAttribute('data-theme', saved);

  const icon = document.getElementById('themeToggleIcon');
  const drawerText = document.getElementById('themeToggleDrawerText');
  if (icon) icon.textContent = saved === 'dark' ? '☀️' : '🌙';
  if (drawerText) {
    drawerText.textContent = saved === 'dark' ? '☀️ Activar Modo Claro' : '🌙 Activar Modo Oscuro';
  }
}

window.toggleThemeFootarchy = function() {
  const html = document.documentElement;
  const current = html.getAttribute('data-theme') || 'dark';
  const next = current === 'dark' ? 'light' : 'dark';
  html.setAttribute('data-theme', next);
  try {
    localStorage.setItem('ft_theme', next);
  } catch (e) {}

  const icon = document.getElementById('themeToggleIcon');
  const drawerText = document.getElementById('themeToggleDrawerText');
  if (icon) icon.textContent = next === 'dark' ? '☀️' : '🌙';
  if (drawerText) {
    drawerText.textContent = next === 'dark' ? '☀️ Activar Modo Claro' : '🌙 Activar Modo Oscuro';
  }
};

/* ==========================================================================
   2. BEFORE / AFTER INTERACTIVE SLIDER (ZERO LAYOUT THRASHING)
   ========================================================================== */
function initBeforeAfterSliders() {
  const sliders = document.querySelectorAll('[data-ft-slider], #baComparator');
  sliders.forEach(container => {
    if (container.dataset.ftSliderInit === 'true') return;
    container.dataset.ftSliderInit = 'true';

    const afterLayer = container.querySelector('.ft-layer-after, .ft-ba-after');
    const handle = container.querySelector('.ft-handle, .ft-ba-handle');
    if (!afterLayer || !handle) return;

    handle.style.touchAction = 'none';

    let isDragging = false;
    let cachedRect = null;
    let rafId = null;

    function setPosition(xPercent) {
      const clamped = Math.min(Math.max(xPercent, 0), 100);
      afterLayer.style.clipPath = `polygon(${clamped}% 0, 100% 0, 100% 100%, ${clamped}% 100%)`;
      handle.style.left = `${clamped}%`;
      handle.setAttribute('aria-valuenow', String(Math.round(clamped)));
    }

    function onPointerMove(e) {
      if (!isDragging || !cachedRect || cachedRect.width <= 0) return;
      const clientX = typeof e.clientX === 'number'
        ? e.clientX
        : (e.touches && e.touches[0] ? e.touches[0].clientX : 0);

      const x = clientX - cachedRect.left;
      const percent = (x / cachedRect.width) * 100;

      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        setPosition(percent);
      });
    }

    function onPointerDown(e) {
      isDragging = true;
      cachedRect = container.getBoundingClientRect();
      container.classList.add('ft-dragging');
      onPointerMove(e);
      window.addEventListener('pointermove', onPointerMove, { passive: true });
      window.addEventListener('pointerup', onPointerUp, { once: true });
      window.addEventListener('pointercancel', onPointerUp, { once: true });
    }

    function onPointerUp() {
      isDragging = false;
      cachedRect = null;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      container.classList.remove('ft-dragging');
      window.removeEventListener('pointermove', onPointerMove);
    }

    container.addEventListener('pointerdown', onPointerDown);

    // Navegación por teclado accesible (WCAG 2.1 AA)
    handle.addEventListener('keydown', (e) => {
      const current = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setPosition(current - 5);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setPosition(current + 5);
      }
    });

    setPosition(50);
  });
}

/* ==========================================================================
   3. STICKY ADD TO CART (SECCIONES SECUNDARIAS FUERA DE #ftPdpRoot)
   ========================================================================== */
function initStickyAddToCart() {
  const stickyBar = document.querySelector('.ft-sticky-atc-bar');
  if (!stickyBar || stickyBar.id === 'ftStickyAtc') return;

  const mainBuyButton = document.querySelector('.ft-pdp-buy-btn') || document.querySelector('[data-ft-main-atc]');
  if (!mainBuyButton) return;

  if (stickyBar.dataset.ftStickyInit === 'true') return;
  stickyBar.dataset.ftStickyInit = 'true';

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('ft-sticky-visible', 'ft-visible');
        } else {
          stickyBar.classList.remove('ft-sticky-visible', 'ft-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainBuyButton);
  }

  const stickyBtn = stickyBar.querySelector('.ft-sticky-btn');
  if (stickyBtn && !stickyBtn.hasAttribute('onclick')) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      mainBuyButton.click();
    });
  }
}

/* ==========================================================================
   4. VOLUME TIER / BUNDLE SELECTOR (PARA BLOQUES CON [data-ft-bundle-group])
   ========================================================================== */
function initBundleSelectors() {
  const bundleWrappers = document.querySelectorAll('[data-ft-bundle-group]');
  bundleWrappers.forEach(wrapper => {
    if (wrapper.dataset.ftBundleInit === 'true' || wrapper.closest('#ftPdpRoot')) return;
    wrapper.dataset.ftBundleInit = 'true';

    const cards = wrapper.querySelectorAll('.ft-bundle-card');
    const mainPriceEl = document.querySelector('[data-ft-pdp-price]');
    const comparePriceEl = document.querySelector('[data-ft-pdp-compare]');
    const savingsEl = document.querySelector('[data-ft-pdp-savings]');
    const qtyInput = document.querySelector('input[name="quantity"]') || wrapper.querySelector('.ft-bundle-qty');

    cards.forEach(card => {
      if (card.hasAttribute('onclick')) return;
      card.addEventListener('click', () => {
        cards.forEach(c => c.classList.remove('active'));
        card.classList.add('active');

        const qty = card.dataset.qty || '1';
        const price = card.dataset.price;
        const compare = card.dataset.compare;
        const discountText = card.dataset.discount;

        if (qtyInput) qtyInput.value = qty;
        if (mainPriceEl && price) mainPriceEl.textContent = price;
        if (comparePriceEl && compare) comparePriceEl.textContent = compare;
        if (savingsEl) {
          if (discountText) {
            savingsEl.textContent = discountText;
            savingsEl.style.display = 'inline-block';
          } else {
            savingsEl.style.display = 'none';
          }
        }
      });
    });
  });
}

/* ==========================================================================
   5. TECHNICAL ACCORDIONS (BLINDAJE ANTI-COLISIÓN CON ONCLICK INLINE)
   ========================================================================== */
function initTechnicalAccordions() {
  const accordions = document.querySelectorAll('.ft-accordion-item');
  accordions.forEach(item => {
    if (item.dataset.ftAccInit === 'true' || item.closest('#ftPdpRoot')) return;
    item.dataset.ftAccInit = 'true';

    const trigger = item.querySelector('.ft-accordion-trigger');
    const content = item.querySelector('.ft-accordion-content');
    if (!trigger || !content) return;

    // Si el botón ya tiene su propio manejador onclick inline, no duplicar listener
    if (trigger.hasAttribute('onclick')) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.classList.contains('ft-open');
      const parent = item.closest('.ft-accordion-group');

      if (parent && parent.dataset.single === 'true') {
        parent.querySelectorAll('.ft-accordion-item').forEach(other => {
          if (other !== item) {
            other.classList.remove('ft-open');
            const otherContent = other.querySelector('.ft-accordion-content');
            if (otherContent) otherContent.style.maxHeight = null;
            const otherTrigger = other.querySelector('.ft-accordion-trigger');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (isOpen) {
        item.classList.remove('ft-open');
        content.style.maxHeight = '0px';
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('ft-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* ==========================================================================
   6. AJAX ADD TO CART CON FEEDBACK HÁPTICO & CONTROL DE CONCURRENCIA
   ========================================================================== */
function initAjaxCartForms() {
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  forms.forEach(form => {
    if (form.dataset.ftAjaxBound === 'true') return;
    if (form.id === 'ftPdpForm' || form.hasAttribute('onsubmit') || form.dataset.noAjax === 'true') {
      return;
    }

    form.dataset.ftAjaxBound = 'true';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (form.dataset.ftSubmitting === 'true') return;
      form.dataset.ftSubmitting = 'true';

      const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('button');
      const originalHtml = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>AÑADIENDO...</span>';
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) throw new Error('Error al añadir al carrito');
        const item = await response.json();

        if (submitBtn) {
          submitBtn.classList.add('ft-btn-success');
          submitBtn.innerHTML = '<span>✓ AÑADIDO</span>';
          setTimeout(() => {
            submitBtn.classList.remove('ft-btn-success');
            submitBtn.innerHTML = originalHtml;
            submitBtn.disabled = false;
          }, 1400);
        }

        document.dispatchEvent(new CustomEvent('footarchy:cart-updated', { detail: { item } }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item } }));

        if (window.footarchyCart && typeof window.footarchyCart.open === 'function') {
          window.footarchyCart.open();
        } else {
          window.ftUpdateCartCount();
        }
      } catch (err) {
        console.warn('Footarchy Cart Fallback:', err.message);
        if (submitBtn) {
          submitBtn.innerHTML = originalHtml;
          submitBtn.disabled = false;
        }
        form.submit();
      } finally {
        form.dataset.ftSubmitting = 'false';
      }
    });
  });
}

/* ==========================================================================
   7. SINCRONIZACIÓN UNIVERSAL DE CONTADORES (0ms & Sin llamadas redundantes)
   ========================================================================== */
window.ftUpdateCartCount = async function(explicitCount) {
  try {
    let count = explicitCount;
    if (typeof count !== 'number') {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      count = cart.item_count;
    }

    const countBadges = document.querySelectorAll('[data-ft-cart-count], #ftHeaderCartCount, .cart-count-bubble, #cart-icon-bubble span');
    countBadges.forEach(badge => {
      badge.textContent = count;
      if (badge.hasAttribute('data-ft-cart-count')) {
        badge.style.display = count > 0 ? (badge.classList.contains('ft-cart-pill') ? 'flex' : 'inline-flex') : 'none';
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count } }));
  } catch (e) {}
};

/* ==========================================================================
   8. FEEDBACK TÁCTIL Y VISUAL A 0ms EN BOTONES (INP < 50ms)
   ========================================================================== */
function initButtonFastFeedback() {
  if (window._ftFastFeedbackInit) return;
  window._ftFastFeedbackInit = true;

  let activePressedBtn = null;

  function clearPressedState() {
    if (activePressedBtn) {
      activePressedBtn.style.transform = '';
      activePressedBtn = null;
    }
  }

  document.addEventListener('pointerdown', (e) => {
    const btn = e.target.closest('.ft-btn, .ft-3d-atc-btn, .ft-sticky-btn, .ft-bundle-card, .ft-cart-btn, .ft-upsell-add-btn, .ft-drawer-checkout-btn');
    if (!btn || btn.disabled) return;
    clearPressedState();
    activePressedBtn = btn;
    btn.style.transform = 'scale(0.98)';
    btn.style.transition = 'transform 0.06s ease';
  }, { passive: true });

  window.addEventListener('pointerup', clearPressedState, { passive: true });
  window.addEventListener('pointercancel', clearPressedState, { passive: true });
}